import { useState, useEffect } from "react";

export const useCurrentTime = () => {
  const [timerHours, setTimerHours] = useState(10);
  const [timerMinutes, setTimerMinutes] = useState(10);
  const [timerSeconds, setTimerSeconds] = useState(10);
  const [timerEnd, setTimerEnd] = useState(Date.now() >= +process?.env?.REACT_APP_LIVE_RELEASE_DATE ? true : false);

  useEffect(() => {
    const countDownDate = process?.env?.REACT_APP_LIVE_RELEASE_DATE;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance: Number = +countDownDate - now;
      const hours = Math.floor(
        (+distance % (24 * 60 * 60 * 1000)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((+distance % (60 * 60 * 1000)) / (1000 * 60));
      const seconds = Math.floor((+distance % (60 * 1000)) / 1000);

      if (distance < 0) {
        clearInterval(interval);
        setTimerEnd(true);
      } else {
        //Update timer
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return { timerEnd, timerHours, timerMinutes, timerSeconds };
};

export default useCurrentTime;
